import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from "vuetify"
import VueRouter from "vue-router"
import VueHead from "vue-head"
import App from './App.vue'
import Home from "./components/Home"
import Contact from "./components/Contact"
import PrivacyPolicy from "./components/PrivacyPolicy"
import Confirmation from "./components/Confirmation"
import Music from "./components/Music"
import BookDetails from './components/BookDetails.vue'

// import VueMatomo from 'vue-matomo'

var router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", component: Home },
    { path: "/music/:title/", component: BookDetails, props: true},
    { path: "/music/", component: Music},
    { path: "/contact", component: Contact},
    { path: "/privacy", component: PrivacyPolicy},
    { path: "/signup", component: Confirmation}
  ],
  mode: 'history'
})

Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VueHead)

Vue.config.productionTip = false

// var _paq = window._paq;
// alert(_paq)
Vue.prototype.window = window
Vue.prototype.console = console
Vue.prototype.alert = alert
// Vue.prototype.setTimeout = setTimeout

new Vue({
  render: h => h(App),
  router: router,
  watch: {
    '$route': function() {
      this.checkCookie()
    }
  },
  mounted(){
    // console.log("mounted")
    // this.checkCookie();
  },
  updated(){
    // $route (to, from){
      // console.log("waa")
      // this.checkCookie();
    // }
  },  
  data: {
    modalOn: false
  },
  methods: {
    showModal: function(isOn){
      this.modalOn = isOn
    },
    checkCookie(){
      let cookie = window.localStorage.getItem('cookie:accepted')

      if(cookie == "true"){
        this.setIFrames(true)
      }
    },
    setIFrames(isOn){
      let iframes = document.getElementsByTagName("iframe")
      // console.log(iframes)
      // console.log(isOn)
      for (let i = 0; i < iframes.length; i++)
      {
        if(!isOn){
          if(!iframes[i].hasAttribute("sandbox")){
            iframes[i].setAttribute("sandbox","allow-scripts");
            iframes[i].setAttribute("data-src",iframes[i].getAttribute("src"));
            iframes[i].removeAttribute("src")
          }
        }
        else
        {
          if(iframes[i].hasAttribute("sandbox")){
            iframes[i].removeAttribute("sandbox");
            iframes[i].setAttribute("src",iframes[i].getAttribute("data-src"));
            iframes[i].removeAttribute("data-src");
          }
        }
      }
    }
  }
}).$mount('#app')

